<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>


export default {
  data() {
    return {};
  },
};
</script>



<style>
.overlay_mask {
  width:100%;height:100vh;position: fixed;top:0px;left:0px;background-color: #18181850;z-index: 100000;
}

.loading_circle{
  position: fixed;
  top: calc(50% - 1rem);
  left: calc(50% - 1rem); 
}
</style>